import { GridCol } from '@bob/library'
import { Button } from '@websrc/App/Components/Button/Button'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React, { KeyboardEvent, useEffect, useRef, useState } from 'react'

import * as SC from './SearchModal.style'

export default function SearchModal() {
  const [searchVal, setSearchVal] = useState('')
  const searchRef = useRef<HTMLInputElement>(null)
  const t = useStaticText()

  const handleSubmit = () => {
    const lang = window.location.pathname.split('/')[1]
    window.location.href = `/${lang}/search?search=${searchVal}`
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  useEffect(() => {
    // because the modal has autofocus
    const timeout = setTimeout(() => {
      searchRef.current?.focus()
    }, 120)

    return () => clearTimeout(timeout)
  }, [searchRef])

  return (
    <SC.Wrapper>
      <GridCol phone={6} tablet={9}>
        <SC.SearchInput
          aria-label={t.search.search}
          autoFocus={true}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchVal(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t.search.search}
          ref={searchRef}
          value={searchVal}
        />
      </GridCol>
      <GridCol phone={6} tablet={3}>
        <Button
          color={'black'}
          colorMode={'light'}
          onClick={handleSubmit}
          size={'medium'}
          text={t.search.search}
          type={'primary'}
        />
      </GridCol>
    </SC.Wrapper>
  )
}
